import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { BrazeLogUserRegistered } from '@/components/BrazeCustomEvents';
import { useUser } from '@/hooks/useUser';
// import { OnboardingSlideshow } from '../OnboardingSlideshow';
import OnboardingContent from '../OnboardingContent';

export const OnboardingModal = () => {
  const { data: user } = useUser();
  const dispatch = useDispatch();
  const completeOnboarding = useCallback(
    () => dispatch({ type: 'UI__COMPLETE_ONBOARDING' }),
    [dispatch]
  );

  return (
    <>
      <BrazeLogUserRegistered user={user} />
      {/* <OnboardingSlideshow
        givenName={user.givenName}
        completeOnboarding={completeOnboarding}
      /> */}
      <OnboardingContent completeOnboarding={completeOnboarding} />
    </>
  );
};
